<!--
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author:
 * @Date: 2020-07-06 16:13:01
 * @LastEditTime: 2020-08-17 15:35:15
 * @LastEditors: zhanglei
 * @Description:
 * @FilePath: /desktop/src/views/Home/Home.vue
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
-->
<template>
  <el-container>
    <!-- 左侧栏 start -->
    <NavMenu />
    <!-- 左侧栏 end -->
    <el-container style="width:60%;">
      <!-- 头部 start -->
      <el-header height="56px">
        <Header />
      </el-header>
      <!-- 头部 end -->
      <!-- <el-tag>
        <tags-view v-if="needTagsView" />
      </el-tag> -->
      <!-- 内容 content start -->
      <el-main>
        <router-view></router-view>
      </el-main>
      <!-- 内容 content end -->
    </el-container>
  </el-container>
</template>
<script>
import NavMenu from '@/views/NavMenu/NavMenu'
import Header from '@/views/Header/header'
// import TagsView from '@/layout/components/TagsView'
import { mapState } from 'vuex'
export default {
  name: 'Home',
  data () {
    return {}
  },
  mounted () { },
  methods: {},
  computed: {
    ...mapState({
      needTagsView: state => state.tagsView
    })
  },
  components: {
    NavMenu,
    Header
    // TagsView
  }
}
</script>
<style>
.el-header {
  background-color: #fff;
  color: #333;
  line-height: 56px;
}
.el-aside {
  background-color: #001529;
  color: #333;
  text-align: left;
}
.el-main {
  background: #f2f2f2;
}
.el-container {
  height: 100%;
}
body > .el-container {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/Home.vue